import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/* Router Modules */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    redirect: "/platform/index"
  },
  {
    path: "/platform",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/platform/index"),
        name: "Platform",
        meta: { title: "平台首页", icon: "el-icon-s-home", affix: true }
      }
    ]
  },
  {
    path: "/infoMation",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "index",
        component: () => import("@/views/infoMation/index"),
        name: "InfoMation",
        meta: { title: "个人信息", icon: "", affix: true }
      }
    ]
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/findPwd",
    component: () => import("@/views/find_pwd/index"),
    hidden: true
  },
  {
    path: "/auth-redirect",
    component: () => import("@/views/login/auth-redirect"),
    hidden: true
  },
  {
    path: "/homepage",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", menuRole: ["AL-00"], type: 1 },
    key: "项目首页",
    children: [
      {
        path: "index",
        component: () => import("@/views/homepage/index"),
        name: "Homepage",
        meta: { title: "项目首页", icon: "documentation", affix: true }
      }
    ]
  },
  {
    path: "/company",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "单位管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/company/index"),
        name: "Company",
        meta: {
          title: "单位管理",
          icon: "el-icon-office-building",
          affix: true
        }
      }
    ]
  },
  {
    path: "/role",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "角色管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/role/index"),
        name: "Role",
        meta: { title: "角色管理", icon: "el-icon-user-solid", affix: true }
      }
    ]
  },
  {
    path: "/visit",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "访视管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/visit/index"),
        name: "Visit",
        meta: { title: "访视管理", icon: "form", affix: true }
      }
    ]
  },
  {
    path: "/user",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "用户管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/user/index"),
        name: "User",
        meta: { title: "用户管理", icon: "peoples", affix: true }
      }
    ]
  },
  {
    path: "/info",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "通知管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/info/index"),
        name: "Info",
        meta: { title: "通知管理", icon: "el-icon-s-data", affix: true }
      }
    ]
  },
  {
    path: "/random",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "随机管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/random/index"),
        name: "Random",
        meta: { title: "随机化管理", icon: "el-icon-s-operation", affix: true }
      },
      {
        path: "parameter",
        component: () => import("@/views/random/parameter"),
        name: "Parameter",
        hidden: true,
        meta: {
          title: "详细参数设置",
          icon: "el-icon-s-operation",
          affix: true
        }
      },
      {
        path: "datas",
        component: () => import("@/views/random/datas"),
        name: "Datas",
        hidden: true,
        meta: {
          title: "数据格式设置",
          icon: "el-icon-s-operation",
          affix: true
        }
      }
    ]
  },
  {
    path: "/subjectConfig",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "受试者配置",
    children: [
      {
        path: "index",
        component: () => import("@/views/subjectConfig/index"),
        name: "Visit",
        meta: { title: "受试者配置", icon: "subject_config", affix: true }
      }
    ]
  },
  {
    path: "/blindFundus",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "盲底管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/blindFundus/index"),
        name: "BlindFundus",
        meta: { title: "盲底管理", icon: "clipboard", affix: true }
      },
      {
        path: "blindTest",
        component: () => import("@/views/blindFundus/blindTest"),
        name: "BlindTest",
        hidden: true,
        meta: { title: "受试者盲底手动测试", icon: "clipboard", affix: true }
      }
    ]
  },
  {
    path: "/test",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    children: [
      {
        path: "blindAutomaticTest",
        component: () => import("@/views/test/blindAutomaticTest"),
        name: "blindAutomaticTest",
        meta: { title: "自动化测试", icon: "el-icon-coin ", affix: true }
      }
    ]
  },
  {
    path: "/subjects",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "受试者管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/subjects/index"),
        name: "Subjects",
        meta: { title: "受试者管理", icon: "el-icon-s-custom", affix: true }
      }
    ]
  },
  {
    path: "/fallOff",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "受试者脱落",
    children: [
      {
        path: "index",
        component: () => import("@/views/fallOff/index"),
        name: "FallOff",
        meta: { title: "受试者脱落", icon: "el-icon-s-check", affix: true }
      }
    ]
  },
  {
    path: "/urgent",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "紧急揭盲",
    children: [
      {
        path: "index",
        component: () => import("@/views/urgent/index"),
        name: "Urgent",
        meta: { title: "紧急揭盲", icon: "el-icon-folder-opened", affix: true }
      }
    ]
  },
  {
    path: "/unblinding",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "揭盲管理",
    children: [
      {
        path: "index",
        component: () => import("@/views/unblinding/index"),
        name: "Unblinding",
        meta: { title: "揭盲管理", icon: "el-icon-s-order", affix: true }
      }
    ]
  },
  {
    path: "/operation",
    component: Layout,
    meta: { proTitle: "好项目：NO-1", type: 1 },
    key: "操作轨迹",
    children: [
      {
        path: "index",
        component: () => import("@/views/operation/index"),
        name: "Operation",
        meta: { title: "操作轨迹", icon: "el-icon-s-claim", affix: true }
      }
    ]
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true
  }
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
